import { createContext, ReactNode, useContext, useState } from 'react'

interface AtendimentoEstadoContextProvideProps {
  children: ReactNode
}

interface AtendimentoEstadoContextProps {
  estado: 'Briefing' | 'Proposta' | 'Fabricação' | 'Montagem'
  setEstado: (
    estado: 'Briefing' | 'Proposta' | 'Fabricação' | 'Montagem'
  ) => void
}

const AtendimentoEstadoContext = createContext<
  AtendimentoEstadoContextProps | undefined
>(undefined)

export function AtendimentoEstadoProvider({
  children,
}: AtendimentoEstadoContextProvideProps) {
  const [estado, setEstado] = useState<
    'Briefing' | 'Proposta' | 'Fabricação' | 'Montagem'
  >('Briefing')

  return (
    <AtendimentoEstadoContext.Provider value={{ estado, setEstado }}>
      {children}
    </AtendimentoEstadoContext.Provider>
  )
}

export function useAttendanceState() {
  const context = useContext(AtendimentoEstadoContext)
  if (!context) {
    throw new Error(
      'useAttendanceState deve ser usado dentro de um AttendanceStateProvider'
    )
  }
  return context
}
